import { registerQuery } from 'data-fetching-client';
import http from 'hub-http/clients/apiClient';
import { PAGE_PROPERTY_NAMES } from 'page-lib/constants/propertyNames';
const fetchPersonalizedLandingPages = async ({
  strategyId
}) => {
  const data = await http.post('content-management/search/v1/LANDING_PAGE', {
    data: {
      filterGroups: [{
        filters: [strategyId ? {
          property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
          operator: 'EQ',
          value: strategyId
        } : {
          property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
          operator: 'HAS_PROPERTY'
        }]
      }],
      sorts: [{
        property: PAGE_PROPERTY_NAMES.PERSONALIZATION_STRATEGY_ID,
        order: 'DESC'
      }]
    }
  });
  return data;
};
export const PERSONALIZED_LANDING_PAGES_QUERY_FIELD_NAME = 'personalizedLandingPages';
export const PersonalizedLandingPagesQuery = registerQuery({
  fieldName: PERSONALIZED_LANDING_PAGES_QUERY_FIELD_NAME,
  fetcher: fetchPersonalizedLandingPages,
  args: ['strategyId']
});